import { Layout } from "@/components/layout";

export default function TermsOfService() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>

        <div className="prose prose-pink max-w-none">
          <p className="text-gray-600 mb-8">Last updated: April 1, 2025</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Hey There!</h2>
          <p>
            Welcome to Vow Quiz! These are the rules for using our site and
            services. By jumping in, you’re agreeing to follow them.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">What You Can Do</h2>
          <p>
            Vow Quiz is your spot for fun wedding quizzes. Use it however you
            like, as long as it’s legal and fits these rules.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Your Account</h2>
          <p>
            Sign up with real info, and keep your password safe. You’re in
            charge of your account.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Quiz Rules</h2>
          <p>When making quizzes, keep it nice:</p>
          <ul className="list-disc pl-6 mb-4 mt-2">
            <li>No rude or harmful stuff</li>
            <li>Don’t steal other people’s work</li>
            <li>Keep private info out of public quizzes</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">Our Stuff</h2>
          <p>
            Vow Quiz and everything on it belongs to us. Don’t copy it without
            permission.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Refunds</h2>
          <p>Not happy with our premium stuff? Here’s the deal:</p>
          <ul className="list-disc pl-6 mb-4 mt-2">
            <li>Get a full refund within 7 days—just email us</li>
            <li>Reach us at hello@vowquiz.com</li>
            <li>We might say no if it seems like a trick</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">
            Our Responsibility
          </h2>
          <p>
            If something goes wrong, we’re not on the hook for big damages—just
            what you paid us, if anything.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Updates</h2>
          <p>
            We might tweak these rules. We’ll let you know if it’s a big change.
            Keep using Vow Quiz, and you’re cool with the updates.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Breaking Up</h2>
          <p>
            If you break these rules or cause trouble, we can shut down your
            account—no warning needed.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Questions?</h2>
          <p>
            Hit us up at hello@vowquiz.com if you’re curious about any of this.
          </p>
        </div>
      </div>
    </Layout>
  );
}
